/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 使用場所情報
 */
export interface Sgkb986aResEmpposInfoDto {
    /**
     * 外部接続番号
     */
    extCnnctNo?: string;
    /**
     * 住所コード
     */
    addressCode?: string;
    /**
     * 郵便番号
     */
    postalCode?: string;
    /**
     * 都道府県名称
     */
    description?: string;
    /**
     * 市区郡町村名称
     */
    mptAname?: string;
    /**
     * 町域名称
     */
    townAreaName?: string;
    /**
     * 大字丁目名称
     */
    ooazaName?: string;
    /**
     * 番地・号・分筆号名称
     */
    bantiGoubunptgouAname?: string;
    /**
     * 住宅・棟号漢字テキスト
     */
    supadrKanjiAname1?: string;
    /**
     * 屋号・業種・目標（漢字）
     */
    yagouAname?: string;
}

